
import { AfterViewInit, Component, ElementRef, ViewChild,Input } from '@angular/core';
import { DashboardService } from '@app/_services/dashboard.service';
import { first } from 'rxjs/operators';

declare var google: any;

@Component({
    selector: 'app-pie-chart-request-ratio',
    template: `<div #pieChart style="width: 100%; height: 100%;"></div>`
})
export class PieChartRequestRatioComponent implements AfterViewInit {

    @ViewChild('pieChart') pieChart: ElementRef

    yr: any;

    @Input() set countRequests(countRequests: number) {
      this.yr = countRequests;
      const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
      const options = {
        //pieSliceText: 'value',
        legend: { position: 'top' }
      };
      var getTopTenEmployerResponse2: any;
      this.dashboardService.getRequestratio(this.yr)
      .pipe(first())
      .subscribe(
          data => {
              console.log("getRequestratio response---", data)
              getTopTenEmployerResponse2 = data.respData;

              var datag = new google.visualization.DataTable();
              datag.addColumn('string', 'Month');
              datag.addColumn('number', 'Count');
              datag.addRow(['Positive', getTopTenEmployerResponse2.Positive]);
              datag.addRow(['Negative', getTopTenEmployerResponse2.Negative]);
              chart.draw(datag, options);
          },
          error => {
              console.log(error)
          }      )      
    }
   
    constructor(private dashboardService: DashboardService) { }
    currentyear =(new Date()).getFullYear();
    chartdata: any;
    // getTopTenEmployerResponse: any;
    result = [];
    drawChart = () => {
        let datatbl = google.visualization.arrayToDataTable([
            ['Task', 'Hours per Day'],           
        ]);
        var getTopTenEmployerResponse1: any;
        this.dashboardService.getRequestratio(this.currentyear)
            .pipe(first())
            .subscribe(
                data => {
                    console.log("getRequestratio response---", data)
                    getTopTenEmployerResponse1 = data.respData;
                    var datag = new google.visualization.DataTable();
                    datag.addColumn('string', 'Month');
                    datag.addColumn('number', 'Count');
                    datag.addRow(['Positive', getTopTenEmployerResponse1.Positive]);
                    datag.addRow(['Negative', getTopTenEmployerResponse1.Negative]);
                    chart.draw(datag, options);
                },
                error => {
                    console.log(error)
                }
            )
        const options = {
            //pieSliceText: 'value',
            legend: { position: 'top' }
        };
        const chart = new google.visualization.PieChart(this.pieChart.nativeElement);
    }

    ngAfterViewInit() {
        google.charts.load('current', { 'packages': ['corechart'] });
        google.charts.setOnLoadCallback(this.drawChart);
    }
}